export default function LoadingSpinner() {
  return <div className="c-loader"></div>;
}
